import { useSelector } from "react-redux";
import { Title, List } from "@vshp/ui-components";
import infoBg from "../../../public/images/hero.jpg";
import Head from "next/head";
import Image from "next/image";
import Link from "next/link";

function Info({ childNum, pathnamePage }) {
  const { settingsOrg } = useSelector((state) => state.settingsOrg);

  return (
    <>
      <Head>
        <title>{settingsOrg.pages[0].children[childNum].title}</title>
      </Head>

      <div className="page__header">
        <Image className="page__header-cover" src={infoBg} alt={settingsOrg.pages[0].children[childNum].title} placeholder="blur" />
        <div className="page__header-body page__header-body_center">
          <Title decor={false} className="page__header-title">
            {settingsOrg.pages[0].children[childNum].title}
          </Title>
          <div className="page__header-intro wysiwyg" dangerouslySetInnerHTML={{ __html: settingsOrg.description }}></div>
        </div>
      </div>
      <div className="page__blocks">
        <div className="page__block">
          <Title>{settingsOrg.pages[0].children[childNum].title}</Title>
          <p>
            В соответствии с нормативными документами "Об утверждении требований к структуре официального сайта образовательной организации в информационно-телекоммуникационной сети "Интернет" и
            формату представления на нем информации" образовательная организация разместила на своем официальном сайте всю необходимую информацию, представленную в соответствующих разделах. Вся
            информация проверена сотрудниками и доступна для просмотра без необходимости регистрации или иных дополнительных действий, препятствующих ее получению. Информация представлена в виде
            набора страниц, имеющих общую навигацию. Для навигации по разделам, используйте меню. Все разделы содержат доступные для посетителей ссылки на файлы, снабженные информацией, поясняющей
            назначение данных файлов, их тип и размер (не превышает 15 Мб).
          </p>
          <List noBorderLast={true}>
            {settingsOrg.pages[0].children[childNum].children.map((item, key) => (
              <Link className="border_bottom" href={`${pathnamePage}/${item.slug}`} key={key}>
                <List.Item className="page-list__item" title={item.title} />
              </Link>
            ))}
          </List>
        </div>
      </div>
    </>
  );
}

export default Info;
